module.exports = __webpack_public_path__ + "media/promo/hoch2023ru/images/rec_bg_2-48d1f1f68f2669ceb00bbeed8d1c6ebc.svg";